// extracted by mini-css-extract-plugin
export var previewContainer = "_sf-0";